module.exports = __webpack_public_path__ + "img/g898.f6133f84.png";